export default __webpack_public_path__ + "static/media/account-settings.31dbeaee.svg";